<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
const props = withDefaults(
  defineProps<{ innerText?: string; index?: number }>(),
  {
    innerText: '大标题'
  }
);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1024 42">
  <g id="xiaobiao2" transform="translate(0 -3)">
    <g id="矩形_2759" data-name="矩形 2759" transform="translate(67 3)" fill="#fff" stroke="var(--theme-color-1)" stroke-width="1">
      <rect width="265" height="42" stroke="none"/>
      <rect x="0.5" y="0.5" width="264" height="41" fill="none"/>
    </g>
    <rect id="矩形_2760" data-name="矩形 2760" width="9" height="42" transform="translate(68 3)" fill="var(--theme-color-1)"/>
    <line id="直线_682" data-name="直线 682" x2="70" transform="translate(5.5 24.5)" fill="none" stroke="var(--theme-color-1)" stroke-width="2"/>
    <circle id="椭圆_800" data-name="椭圆 800" cx="5.5" cy="5.5" r="5.5" transform="translate(0 19)" fill="var(--theme-color-1)"/>
    <text id="执行人男性年龄分布" transform="translate(95.355 31)" fill="#222" font-size="22" font-weight="600"><tspan x="0" y="0">${props.innerText}</tspan></text>
  </g>
</svg>
`;
</script>
<style lang="scss" scoped></style>
